import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Disc3, Check } from "lucide-react";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate(user.role === "admin" ? "/admin" : "/dashboard");
  }, [user, loading, navigate]);

  return (
    <div className="grain min-h-screen relative flex items-center justify-center px-6">
      <img src="https://images.pexels.com/photos/6707302/pexels-photo-6707302.jpeg" alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-black/80 to-black/60" />
      <div className="relative z-10 w-full max-w-md text-center">
        <img src="/logo.png" alt="Ceinaru Media" className="h-16 w-16 mx-auto mb-6" />
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">Welcome to <span className="text-[#D90429]">Ceinaru Media</span></h1>
        <p className="text-[#A0A0A0] mt-4">Sign in to reserve studio time and manage your sessions.</p>

        <div className="mt-8 text-left bg-white/5 border border-white/10 p-5">
          <p className="text-xs leading-relaxed text-[#A0A0A0]">
            Please note that our team is saving your email address for booking-related reasons and for possible future newsletters and promotional notifications.
          </p>
          <label
            data-testid="consent-checkbox-label"
            className="mt-4 flex items-start gap-3 cursor-pointer select-none group"
          >
            <span
              className={`mt-0.5 h-5 w-5 flex-shrink-0 flex items-center justify-center border transition-colors ${
                agreed ? "bg-[#D90429] border-[#D90429]" : "border-white/30 group-hover:border-white/60"
              }`}
            >
              {agreed && <Check className="h-3.5 w-3.5 text-white" />}
            </span>
            <input
              type="checkbox"
              className="sr-only"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              data-testid="consent-checkbox"
            />
            <span className="text-sm text-white font-semibold">Agree with this</span>
          </label>
        </div>

        <button
          onClick={() => {
            localStorage.setItem("consent_given_at", new Date().toISOString());
            login();
          }}
          disabled={!agreed}
          data-testid="google-login-button"
          className="mt-6 w-full bg-white text-black py-4 font-bold uppercase tracking-wide flex items-center justify-center gap-3 hover:bg-[#D90429] hover:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-black">
          <Disc3 className="h-5 w-5" /> Continue with Google
        </button>
        <p className="text-xs text-[#A0A0A0] mt-6">Reserve online · Pay at the studio</p>
      </div>
    </div>
  );
}
